import { Button, Card, Flex, Text, Title } from '@mantine/core';
import { IconCheck, IconRefresh } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useBaleCreateContext } from '../hook';
import styles from '../styles.module.css';

export const BaleCreateSuccessPage = () => {
	const { resetWorkflow } = useBaleCreateContext();
	const navigate = useNavigate();

	return (
		<Flex pos="absolute" h="100vh" w="100%" className={styles.pageBackground}>
			<Flex direction="column" align="center" justify="center" h="100%" w="100%" p="md">
				<Card shadow="md" p="xl" radius="md" bg="white" w="100%" maw={400} mx="auto">
					<Flex direction="column" align="center" gap="lg">
						<Flex
							align="center"
							justify="center"
							w={80}
							h={80}
							bg="green.6"
							style={{ borderRadius: '50%' }}
						>
							<IconCheck size={40} color="white" />
						</Flex>
						<Title order={2} ta="center" c="dark">
							Bale Created Successfully
						</Title>
						<Text size="md" ta="center" c="dimmed">
							Your bale has been created and is ready for processing.
						</Text>
					</Flex>
				</Card>
			</Flex>
			<Flex
				className={styles.successBottomButtons}
				pos="fixed"
				bottom={0}
				left={0}
				right={0}
				p="md"
				bg="white"
				w="100%"
				gap="sm"
			>
				<Button
					onClick={resetWorkflow}
					variant="outline"
					color="gray"
					size="lg"
					leftSection={<IconRefresh size={16} />}
					fullWidth
					className={styles.successButton}
				>
					Create Another
				</Button>
				<Button
					onClick={() => navigate({ to: '/facility/home' })}
					variant="filled"
					color="green"
					size="lg"
					leftSection={<IconCheck size={16} />}
					fullWidth
					className={styles.successButton}
				>
					Done
				</Button>
			</Flex>
		</Flex>
	);
};
